import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from '@/state/types/auth'

const defaultState = {
  user: false,
}

export default (previousState = defaultState, { type, payload }) => {
  switch (type) {
    case LOGIN_SUCCESS:
      return { ...previousState, user: payload.user }
    case LOGOUT:
    case LOGIN_FAILURE:
      return defaultState
    default:
      return previousState
  }
}



// WEBPACK FOOTER //
// ./state/reducers/auth.js